// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2FD-8","left":"StickyBox_left__29bjj","right":"StickyBox_right__2mmT6"};